import { supabase } from './SupabaseConfig';
import { ManagerRepository } from '@domain/identity/ports/ManagerRepository';
import { InfrastructureError } from '@core/errors/AppError';

export class SupabaseManagerRepository implements ManagerRepository {
  async getManagers(ownerId: string): Promise<any[]> {
    try {
      const { data, error } = await supabase
        .from('managers')
        .select('*')
        .eq('owner_id', ownerId)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      throw new InfrastructureError('Lỗi lấy danh sách quản lý', 'Supabase', error as Error);
    }
  }

  async getManagerProfile(ownerId: string, managerId: string): Promise<any | null> {
    try {
      const { data, error } = await supabase
        .from('managers')
        .select('*')
        .eq('id', managerId)
        .eq('owner_id', ownerId)
        .single();

      if (error) {
        if (error.code === 'PGRST116') return null;
        throw error;
      }
      return data;
    } catch (error) {
      throw new InfrastructureError('Lỗi lấy hồ sơ quản lý', 'Supabase', error as Error);
    }
  }

  async createManagerProfile(ownerId: string, managerData: any): Promise<void> {
    try {
      const { error } = await supabase
        .from('managers')
        .insert({
          ...managerData,
          owner_id: ownerId,
          updated_at: new Date().toISOString()
        });

      if (error) throw error;
    } catch (error) {
      throw new InfrastructureError('Lỗi lưu hồ sơ quản lý', 'Supabase', error as Error);
    }
  }

  async updateManagerProfile(ownerId: string, managerId: string, updates: any): Promise<void> {
    try {
      const { error } = await supabase
        .from('managers')
        .update({
          ...updates,
          updated_at: new Date().toISOString()
        })
        .eq('id', managerId)
        .eq('owner_id', ownerId);

      if (error) throw error;
    } catch (error) {
      throw new InfrastructureError('Lỗi cập nhật hồ sơ quản lý', 'Supabase', error as Error);
    }
  }

  listenManagers(ownerId: string, callback: (managers: any[]) => void): () => void {
    const channel = supabase
      .channel(`managers-${ownerId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'managers',
          filter: `owner_id=eq.${ownerId}`
        },
        async () => {
          const data = await this.getManagers(ownerId);
          callback(data);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }
}
